import { Injectable } from '@angular/core';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { UrlGeneratorService } from '@app/core/i18n';

@Injectable()
export class I18nRedirector {
  private path = '/';

  constructor(private urlGenerator: UrlGeneratorService, private platform: PlatformService) {}

  redirect(localeId: string): void {
    if (!this.platform.isBrowser) {
      return;
    }
    location.reload();
    // location.replace(this.getRedirectUrl(localeId));
  }

  getRedirectUrl(localeId: string) {
    return this.urlGenerator.generateUrl(this.path, localeId);
  }
}
